<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="预测名称：">
              <global-select
                @change="handleNameChange"
                :value.sync="queryParams.forecastName"
                selectType="selectSearch"
                requestApi="/scp/salesForecast/forecastNamePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="forecastName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="期间">
              <!-- <a-input v-model="queryParams.startMonth"/> -->
              <global-select
                :focusGet="true"
                @change="handleMonthChange"
                :setParams="{forecastName:queryParams.forecastName}"
                :value.sync="queryParams.forecastMonthTem"
                selectType="selectSearch"
                requestApi="/scp/salesForecast/monthPeriodPullDown"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.versionCode"
                selectType="select"
                requestApi="/scp/salesForecast/versionCodePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="版本说明">
                <a-input v-model="queryParams.versionDescription"/>
              </a-form-item>
            </a-col>
          </template> -->
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:salesForecast:add']">新增</a-button>
      <a-button @click="$refs.createExport.show()" type="primary" v-hasPermi="['scp:salesForecast:import']">导入</a-button>
      <a-button @click="$refs.createComparisonExport.show()" type="primary">预测对比</a-button>
      <a-button @click="importTemplate" v-hasPermi="['scp:salesForecast:template']">下载模版</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SALES_FORECAST_WORK_DESK_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="forecastName" slot-scope="{ record, text }">
            <a @click="handleOperation(text,record)" class="ml10">{{ record.versionCode }}</a>
          </span>

          <span slot="operation" slot-scope="{ record }">
            <a @click="handleDelete(record)" v-hasPermi="['scp:salesForecast:remove']">删除</a>
          </span>
        </ls-api-table>
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          :maskClosable="false"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
        <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
        <create-export
          ref="createExport"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
        <create-comparison-export
          ref="createComparisonExport"
          :uomClassOptions="uomClassOptions"
          @handle-export-confirm="handleExportConfirm"
          @handle-success="handleOk"></create-comparison-export>
        <download-modal :apiFun="apiExportForecastContrast" ref="download" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apisalesForecastList, apiDeleteSalesForecast, apiExportForecastContrast } from '@/api/scp/salesForecast/salesForecastWorkDesk'
import CreateForm from './components/CreateForm'
import CreateExport from './components/CreateExport'
import CreateComparisonExport from './components/CreateComparisonExport.vue';
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  // eslint-disable-next-line
  name: 'Sales-forecast',
  components: {
    CreateForm,
    CreateExport,
    CreateComparisonExport,
    DownloadModal
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiExportForecastContrast,
            // 导入excel
     excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/salesForecast/import'
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apisalesForecastList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        // 预测名称
        forecastName: undefined,
         // 版本
        versionCode: undefined,
        startMonth: '',
        versionDescription: '',
        forecastMonthStart: '',
        forecastMonthEnd: '',
        forecastMonthTem: ''
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '预测名称',
          dataIndex: 'forecastName',
          ellipsis: true,
          align: 'center',
          width: 180
        },
        {
          title: '版本',
          width: 160,
          dataIndex: 'versionCode',
          scopedSlots: { customRender: 'forecastName' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '版本说明',
          dataIndex: 'versionDescription',
          ellipsis: true,
          width: 180,
          align: 'left'
        },
        {
          title: '预测起始月',
          dataIndex: 'forecastMonthStart',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '预测截止月',
          dataIndex: 'forecastMonthEnd',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          width: 100,
          align: 'center'
        },
        {
          title: '创建时间',
          width: 180,
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          width: 180,
          dataIndex: 'updateTime',
          align: 'center'
        },
        {
          title: '操作',
          stickyFixed: 'right',
          align: 'center',
          width: 80,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      uomClassOptions: [],
      unitOfMeasureList: [],
      unitOfMeasureListNew: []
    }
  },
  created () {
    this.getUnitOfMeasureList()
    const lookupQueryParams = {
      lookupType: 'MDM_UOM_CLASSES',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(lookupQueryParams).then().then(response => {
      this.uomClassOptions = response.rows
    })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    handleDelete (record) {
         const self = this
        this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
        apiDeleteSalesForecast({ id: record.id }).then(response => {
        if (response.code === 200) {
          self.$message.success('删除成功')
          self.onSearch()
        } else {
          self.$message.error(response.msg)
        }
      })
        }
      })
    },
     /** 下载模板操作 */
        importTemplate () {
      this.download('scp/salesForecast/template', {
        ...this.queryParams
      }, `销售预测导入模板_${new Date().getTime()}.xlsx`)
    },
        /** 导入excel */
     importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    handleOperation (text, record) {
      this.$router.push({ path: `/salesForecast/detail/${record.forecastName}/${record.versionCode}/${record.versionDescription}` })
    },
    handleNameChange (val, selectList) {
      // const filteredItem = selectList.filter(item => item.realValue === val);
      // this.queryParams.startMonth = filteredItem[0].bringOutDataOne
    },
    handleVersionChange (val, selectList) {
      const filteredItem = selectList.filter(item => item.realValue === val);
     this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
    },
    handleMonthChange (val, selectList) {
     // const filteredItem = selectList.filter(item => item.selectedValue === val);
        const [startStr, endStr] = val.split('-');
        this.queryParams.forecastMonthStart = startStr
        this.queryParams.forecastMonthEnd = endStr
    },
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record) {
      record.status = record.status === 'Y' ? 'N' : 'Y'
    },
    handleImport () {
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/salesForecast/exportForecastContrast', {
        ...this.queryParams
      }, `销售预测对比_${new Date().getTime()}.xlsx`)
    },
    getUnitOfMeasureList () {

    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        forecastName: undefined,
         // 版本
        versionCode: undefined,
        startMonth: '',
        versionDescription: '',
        forecastMonthStart: '',
        forecastMonthEnd: '',
        forecastMonthTem: ''
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleExportConfirm (params) {
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
